import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GenericStudentCardComponent } from '../generic-student-card/generic-student-card.component';
import { AdminActionsComponent } from '../student-card-actions/admin-actions/admin-actions.component';
import { GraduationActionsComponent } from '../student-card-actions/graduation-actions/graduation-actions.component';
import { SchoolRosterStudent } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-student-card',
  template: `
    <lib-generic-student-card
      #card
      [editable]="editable"
      [student]="student"
      [schoolTermGrades]="schoolTermGrades"
      [schoolGradeYears]="schoolGradeYears"
      [attendanceTypes]="attendanceTypes"
      [isExpanded]="isExpanded"
      [lockPriorTermCosts]="!showAdminActions"
      (toggleExpand)="toggleExpand.emit($event)">
      @if (showAdminActions) {
        <lib-admin-actions
          studentCardActions
          [student]="student"
          [form]="card.form"
          [isNotAttending]="card.isNotAttending"
          [individualCostErrors]="card.individualCostErrors"
          (saved)="onSaved($event)"
          (reverted)="onReverted($event)"
          (validateForm)="card.validateIndividualCost()"
          (syncFormToModel)="card.syncFormToModel()">
        </lib-admin-actions>
      } 
      @if(editable) 
      {
        <lib-graduation-actions
          studentCardActions
          [student]="student"
          [form]="card.form"
          (graduated)="onSaved($event)"
          (cancelForm)="card.resetForm()">
        </lib-graduation-actions>
      }
    </lib-generic-student-card>
  `,
  standalone: true,
  imports: [GenericStudentCardComponent, AdminActionsComponent, GraduationActionsComponent]
})
export class StudentCardComponent extends GenericStudentCardComponent {
  @Input() override editable = false;
  @Input() override isExpanded = false;
  @Input() showAdminActions = false;
  @Input() onSavedCallback?: (studentEnrollmentId: string) => void;
  @Input() onRevertedCallback?: (studentEnrollmentId: string) => void;
  @Input() onWithdrawalCallback?: (student: SchoolRosterStudent) => void;
  @Output() saved = new EventEmitter<string>();
  @Output() reverted = new EventEmitter<string>();

  constructor() {
    super();
  }

  onSaved(studentEnrollmentId: string): void {
    this.saved.emit(studentEnrollmentId);
    if (this.onSavedCallback) {
      this.onSavedCallback(studentEnrollmentId);
    }
  }

  onReverted(studentEnrollmentId: string): void {
    this.reverted.emit(studentEnrollmentId);
    if (this.onRevertedCallback) {
      this.onRevertedCallback(studentEnrollmentId);
    }
    if (this.onActionCompleted) {
      this.onActionCompleted(studentEnrollmentId);
    }
  }
}
